import { ShoppingCart, Zap, Percent } from 'lucide-react';

export const StickyCheckoutBar = ({ 
  product, 
  stock, 
  selectedSize, 
  selectedColor, 
  onAddToCart, 
  onBuyNow 
}) => {
  const isOutOfStock = stock === 0;
  const price = product?.discount_price || product?.price || 0;

  return (
    <div 
      className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-lg z-40 lg:hidden"
      data-testid="sticky-checkout-bar"
    >
      {/* Offer Banner */}
      <div className="bg-gradient-to-r from-[#C59746] to-[#B8860B] px-4 py-1.5 text-center">
        <p className="text-white text-xs font-medium flex items-center justify-center gap-1">
          <Percent className="w-3 h-3" />
          Get 5% extra discount on prepaid orders
        </p>
      </div>

      {/* Main Bar */}
      <div className="px-4 py-3 flex items-center gap-3">
        {/* Price Section */}
        <div className="flex-shrink-0">
          <p className="text-lg font-bold text-[#1A1A1A]">₹{price}</p>
          {product?.discount_price && (
            <p className="text-xs text-gray-400 line-through">₹{product.price}</p>
          )}
        </div>

        {/* Buttons */}
        <div className="flex-1 flex gap-2">
          <button
            onClick={onAddToCart}
            disabled={isOutOfStock || !selectedSize}
            className={`flex-1 flex items-center justify-center gap-1.5 py-3 px-3 rounded-lg font-semibold text-sm transition-all ${
              isOutOfStock || !selectedSize
                ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                : 'bg-white border-2 border-[#C59746] text-[#C59746] hover:bg-[#C59746]/5 active:scale-95'
            }`}
            data-testid="sticky-add-to-cart"
          >
            <ShoppingCart className="w-4 h-4" />
            <span className="hidden sm:inline">ADD TO CART</span>
            <span className="sm:hidden">CART</span>
          </button>

          <button
            onClick={onBuyNow}
            disabled={isOutOfStock || !selectedSize}
            className={`flex-1 flex items-center justify-center gap-1.5 py-3 px-3 rounded-lg font-semibold text-sm transition-all ${
              isOutOfStock || !selectedSize
                ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                : 'bg-[#C59746] text-white hover:bg-[#B8860B] active:scale-95'
            }`}
            data-testid="sticky-buy-now"
          >
            <Zap className="w-4 h-4" />
            <span>{isOutOfStock ? 'OUT OF STOCK' : 'BUY NOW'}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default StickyCheckoutBar;
